export const ListItemTypes = {
  completed: 'checked',
  uncompleted: 'unchecked',
  nextToBeDone: 'nexttobedone',
};
